import styled from '@emotion/styled';
import Dropdown from '@comp/Dropdown/Dropdown';
import P2 from '@base/P2/P2';
import { Fonts, Spacings } from '@styles/index';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledDropdown = styled(Dropdown)`
  height: 60px;
  width: 100%;
`;

const StyledP2 = styled(P2)`
  font-weight: ${Fonts.SEMIBOLD};
  color: var(--color-i-red);
  margin-top: ${Spacings.SPACING_2B};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const ErrorWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${Spacings.SPACING_6B};
`;

export default function DropdownInput(props) {
  const { options, selectedOption, placeholder, handleClick, error, errorMsg } =
    props;

  return (
    <Wrapper>
      <StyledDropdown
        // @ts-ignore
        onOptionClick={handleClick}
        selectedOption={selectedOption}
        placeholder={placeholder}
        options={options}
        menuColor="var(--color-i-blue)"
        gridColumn="span 1"
        displayCheck
      />
      <ErrorWrapper>{error && <StyledP2>{errorMsg}</StyledP2>}</ErrorWrapper>
    </Wrapper>
  );
}
